import { render, staticRenderFns } from "./PerkSpotLandingPage.vue?vue&type=template&id=b1984538"
import script from "./PerkSpotLandingPage.vue?vue&type=script&lang=js"
export * from "./PerkSpotLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports